import { render, staticRenderFns } from "./PriceAreaFormModal.vue?vue&type=template&id=4427d492&"
import script from "./PriceAreaFormModal.ts?vue&type=script&lang=js&"
export * from "./PriceAreaFormModal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports